var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fourSymbolsLineDiagram"},[_c('div',{ref:"chartEl",staticClass:"ElephantLine",attrs:{"id":'ElephantLine_' + _vm.id_type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }